import React, {useContext} from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from "@mui/material/Stack";
import {useLocation, useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar/Avatar";
import axios from "axios";
import {AuthUserContext} from "../../providers/AuthProvider";
import {useFormik} from "formik";
import AddAdminValidation from "../../validation/add-admin";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Portal from "@mui/material/Portal";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import ContactUser from "../../helpers/contact-user";
import firebase from "../../firebase/firebase";
import moment from "moment/moment";

export default function ManageAdminDetails(){

  const [open, setOpen] = React.useState(false);
  const [removeAdminLoading,setLoadingRemove] = React.useState(false);
  const [isLoading,setLoading] = React.useState(false);
  const [isLoadingUser,setLoadingUser] = React.useState(false);

  const contactUser = async (uid) => {
    try {
      setLoadingUser(true)
      const id = await ContactUser(profile, admin.uid)
      setLoadingUser(false)
      navigator('/admin/chat')

    } catch (e) {
      setLoadingUser(false)
    }
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const location = useLocation()
  const navigator = useNavigate()
  const {profile} = useContext(AuthUserContext);

  const [admin, setAdmin] = React.useState({...location.state.admin, userType: location.state.admin.super === true ? 'super-admin': 'admin'});
  const [isAddForm, setAddForm] = React.useState(false)
  const [activitiesView, setActivitiesView] = React.useState(false)
  const [notifications, setNotifications] = React.useState([])

  const formik = useFormik({
    initialValues: {...admin, password: ''},
    validationSchema: AddAdminValidation.AddAdminSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        const {name,
          email,
          contact,
          userType,
          password} = values;
        const response = await axios.post(
          'https://api-taost.herokuapp.com/api/v1/secure/update-admin',
          // 'http://localhost:8080/api/v1/secure/update-admin',
          {uid:admin?.uid, id: admin?.id , formData: {name,
              email,
              phoneNumber: contact,
              userType: 'admin', super: userType === 'super-admin',
              password}
          },
          { headers: { 'Content-Type': 'application/json', 'Id-Token': profile?.idToken}  }
        )
        setAddForm(!isAddForm)
        setLoading(false)
        navigator('/admin/manage');

        // alert(JSON.stringify(response))
      } catch (e) {
        setLoading(false)
        console.log(e)
      }
    },
  });

  const showAddForm = () => {
    setAddForm(!isAddForm)

  }
  const deleteAdmin = async () => {
    setLoadingRemove(true)
    try {
      const response = await axios.post(
        'https://api-taost.herokuapp.com/api/v1/secure/delete-admin',
        // 'http://localhost:8080/api/v1/secure/delete-admin',
        {id: admin.id, uid: admin.uid},
        { headers: { 'Content-Type': 'application/json','Id-Token': profile?.idToken}   }
      )
      handleClose()
      setLoadingRemove(false)
      navigator('/admin/manage')

    } catch (e) {
      setLoadingRemove(false)

    }
  }
  React.useEffect(() => {

    const notificationsRef = firebase.firestore().collection('activities').orderBy('createdAt', 'desc');
    notificationsRef
      .where('uid', '==', admin?.uid)
      .limit(10)
      .get()
      .then((data) => {
        if (data?.size > 0) {
          const list = []
          data.docs.forEach((d) => {
            list.push({id: d.id, ...d.data()})
          })
          setNotifications(list);
        }
      })

  }, [])
  return (
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left',overflowY: 'scroll'}}>

      {isAddForm ?
        <Stack direction={'column'} spacing={5} >
          <Stack direction={'row'} spacing={3}>
            <Typography variant={'h4'} color={'primary'}>
              Manage Admin
            </Typography>
            <Typography variant={'h4'} color={'primary'}>
              >
            </Typography>
            <Typography variant={'h4'} color={'primary'}>
              Edit information
            </Typography>
          </Stack>
          <Stack component={'form'} onSubmit={formik.handleSubmit} direction="column"
                 justifyContent="flex-start"
                 alignItems="center"
                 spacing={3}>

            <TextField value={formik.values.name}
                       onChange={formik.handleChange}
                       error={formik.touched.name && Boolean(formik.errors.name)}
                       helperText={formik.touched.name && formik.errors.name}
                       label={'Name'} name="name" variant="outlined" sx={{width:'100%'}} />

            <TextField value={formik.values.email}
                       onChange={formik.handleChange}
                       error={formik.touched.email && Boolean(formik.errors.email)}
                       helperText={formik.touched.email && formik.errors.email}
                       label={'Email'} name="email" variant="outlined" sx={{width:'100%'}} />

            <TextField value={formik.values.contact}
                       onChange={formik.handleChange}
                       error={formik.touched.contact && Boolean(formik.errors.contact)}
                       helperText={formik.touched.contact && formik.errors.contact}
                       label={'Contact'} name="contact" variant="outlined" sx={{width:'100%'}} />

            <TextField value={formik.values.userType}
                       onChange={formik.handleChange}
                       error={formik.touched.userType && Boolean(formik.errors.userType)}
                       helperText={formik.touched.userType && formik.errors.userType}
                       label={'User Type'} name="userType" variant="outlined" sx={{width:'100%'}} select >

              <MenuItem value={'admin'}>
                Admin
              </MenuItem>
              <MenuItem value={'super-admin'}>
                Super Admin
              </MenuItem>
            </TextField>
            <TextField value={formik.values.password}
                       onChange={formik.handleChange}
                       error={formik.touched.password && Boolean(formik.errors.password)}
                       helperText={formik.touched.password && formik.errors.password}
                       label={'Create password'} name="password" variant="outlined" sx={{width:'100%'}} type={'password'} autoComplete={false}/>


            <Stack direction={'row'} spacing={5}>
              <Button onClick={() => setAddForm(!isAddForm)} >Go back</Button>
              <Button variant={'contained'} sx={{px: 3}} type={'submit'} endIcon={isLoading ? <CircularProgress size={20}/> : '' } disabled={isLoading}>
                Save changes
              </Button>
            </Stack>

          </Stack>

        </Stack>
: activitiesView ?
          <Stack direction={'column'} spacing={5} >
            <Stack direction={'row'} spacing={3}>
              <Typography variant={'h4'} color={'primary'} sx={{cursor: 'pointer'}} onClick={() => navigator('/admin/manage')}>
                Manage Admin
              </Typography>
              <Typography variant={'h4'} color={'primary'}>
                >
              </Typography>
              <Typography variant={'h4'} color={'primary'} sx={{cursor: 'pointer'}} onClick={() => setActivitiesView(false)}>
                {admin?.name}
              </Typography>
              <Typography variant={'h4'} color={'primary'}>
                >
              </Typography>
              <Typography variant={'h4'} color={'primary'}>
                Activities
              </Typography>
            </Stack>
            {notifications && notifications.length > 0 && notifications.map((activity) => (
              <Box sx={{ borderBottom:'1px solid #204488', p:1, pb: 3}}>
                <Stack  direction="row"
                        alignItems="center"                 spacing={2}
                >
                  <Typography  sx={{flex:1}}>
                    {activity.text}
                  </Typography>
                  <Typography  variant='caption'>
                    {moment(activity.createdAt.seconds * 1000).format('hh:mm:a')}
                  </Typography>
                </Stack>

              </Box>
            ))}
          </Stack>:
        <Stack direction={'column'} spacing={5}>
          <Stack direction={'row'} spacing={3}>
            <Stack direction={'column'} spacing={3}  style={{flex:1}}>
              <Stack direction={'row'} spacing={3}>
                <Typography variant={'h4'} color={'primary'}>
                  Manage Admin
                </Typography>
                <Typography variant={'h4'} color={'primary'}>
                  >
                </Typography>
                <Typography variant={'h4'} color={'primary'}>
                  {admin?.name}
                </Typography>
              </Stack>
              <div />
              <div />
              <Stack direction={'row'} spacing={3}>
                <Typography variant={'body1'}  sx={{width:120}}>
                  <strong>Name</strong>
                </Typography>
                <Typography variant={'body1'} >
                  {admin?.name}
                </Typography>
              </Stack>
              <Stack direction={'row'} spacing={3}>
                <Typography variant={'body1'}  sx={{width:120}}>
                  <strong>Email</strong>
                </Typography>
                <Typography variant={'body1'}>
                  {admin?.email}
                </Typography>
              </Stack>
              <Stack direction={'row'} spacing={3}>
                <Typography variant={'body1'}  sx={{width:120}}>
                  <strong>Contact</strong>
                </Typography>
                <Typography variant={'body1'}>
                  {admin?.contact}
                </Typography>
              </Stack>
              <Stack direction={'row'} spacing={3}>
                <Typography variant={'body1'}  sx={{width:120}}>
                  <strong>User type</strong>
                </Typography>
                <Typography variant={'body1'}>
                  {admin?.super ? 'Super Admin':'Admin'}
                </Typography>
              </Stack>
              <Stack direction={'row'} spacing={3}>
                <Typography variant={'body1'}  sx={{width:120}}>
                  <strong>Account</strong>
                </Typography>
                <Typography variant={'body1'}>
                  {admin?.active ? admin?.active : 'Active'}
                </Typography>
              </Stack>


            </Stack>
            <Stack direction={'column'}  sx={{  width:300, height:332, p: 2 }} alignItems={'center'} justifyContent={'space-around'} component={Paper}>
              <Avatar  alt={admin?.name} sx={{width: 107, height:107, fontSize:72, backgroundColor:'#E3E8F0', color:'#204488'}}>
                {admin?.name.charAt(0).toUpperCase() }
              </Avatar>
              <Button variant={'contained'} sx={{width: '100%'}} color={'error'} onClick={handleClickOpen}>
                Remove Admin
              </Button>
              <Button variant={'contained'} sx={{width: '100%'}} onClick={() => showAddForm(!isAddForm)}>
                Edit information
              </Button>
              <Button variant={'text'} sx={{width: '100%', textDecoration: 'underline'}} onClick={() => setActivitiesView(true)}>
                See recent activity
              </Button>
            </Stack>
          </Stack>
          <Stack direction={'row'} sx={{ height:332, p: 2 }} alignItems={'center'} justifyContent={'center'} spacing={3}>
            <Button variant={'contained'} sx={{ px: 5}} onClick={contactUser}>
              Contact user
            </Button>
          </Stack>


        </Stack>

      }
      <Portal>
        <div>

          <Dialog
            open={open}
            onClose={handleClose}
            fullWidth={true}
            maxWidth={'sm'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" color={'primary'}>
              Before you move forward...
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                This action will permanently remove the user from admin list.
                Do you want to proceed with this action?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Go back</Button>
              <Button onClick={()=> {
                deleteAdmin();

              }} variant={'contained'} color={'warning'} size={'small'} sx={{px: 3}} endIcon={removeAdminLoading ? <CircularProgress size={20}/> : '' } disabled={removeAdminLoading}>
                Remove admin
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Portal>
    </Container>
  )
}